import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { LineChart, Line, ResponsiveContainer, XAxis, YAxis, Tooltip, PieChart, Pie, Cell, BarChart, Bar } from "recharts";

import {
  FaDownload,
  FaUpload,
  FaSyncAlt,
  FaBullhorn,
  FaInstagram,
  FaGlobe
} from "react-icons/fa";
import { SiWhatsapp } from "react-icons/si";

import { FaBriefcase, FaUserCheck, FaDollarSign } from "react-icons/fa";
import { HiMiniUserGroup } from "react-icons/hi2";

const lineData = [{ value: 40 }, { value: 35 }, { value: 50 }, { value: 45 }, { value: 60 }, { value: 80 }, { value: 70 }, { value: 65 }, { value: 75 }
];

const dealData = [{ value: 15 }, { value: 20 }, { value: 18 }, { value: 25 }, { value: 28 }, { value: 24 }, { value: 30 }
];

const revenueData = [{ value: 40 }, { value: 35 }, { value: 60 }, { value: 15 }, { value: 50 }, { value: 65 }, { value: 20 }, { value: 10 }, { value: 70 }
];

const pieData = [
  { name: "Qualified", value: 75 },
  { name: "Remaining", value: 25 }
];

const COLORS = ["#4e73df", "#eaeaea"];

// -- customline tooltip
const CustomLineTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          background: "#fff",
          padding: "10px 16px",
          borderRadius: "12px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
          fontSize: "14px",
          fontWeight: 500
        }}
      >
        Leads <span style={{ fontWeight: 700 }}>{payload[0].value}</span>
      </div>
    );
  }
  return null;
};

// custome deals tooltip  
const CustomDealsTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          background: "#fff",
          padding: "10px 16px",
          borderRadius: "12px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
          fontSize: "14px",
          fontWeight: 500
        }}
      >
        Deals <span style={{ fontWeight: 700 }}>{payload[0].value}</span>
      </div>
    );
  }
  return null;
};

// custome bar tooltip
const CustomBarTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          background: "#fff",
          padding: "10px 16px",
          borderRadius: "12px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
          fontSize: "14px",
          fontWeight: 500
        }}
      >
        Revenue <span style={{ fontWeight: 700 }}>{payload[0].value}</span>
      </div>
    );
  }
  return null;
};


// iconsstyle 
const iconstyle = {
  width: 50,
  height: 50,
  borderRadius: "50%",
  background: "#f1f3f7",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginRight: 15
};


// section two chartdata

const chartData = [
  { month: "Jan", green: 38, yellow: 18, purple: 20 },
  { month: "Feb", green: 45, yellow: 20, purple: 22 },
  { month: "Mar", green: 50, yellow: 19, purple: 25 },
  { month: "Apr", green: 48, yellow: 23, purple: 28 },
  { month: "May", green: 55, yellow: 22, purple: 26 },
  { month: "Jun", green: 62, yellow: 25, purple: 24 },
  { month: "Jul", green: 58, yellow: 28, purple: 21 },
  { month: "Aug", green: 65, yellow: 30, purple: 27 },
  { month: "Sep", green: 60, yellow: 29, purple: 29 },
  { month: "Oct", green: 72, yellow: 32, purple: 31 },
  { month: "Nov", green: 68, yellow: 33, purple: 30 },
  { month: "Dec", green: 75, yellow: 35, purple: 34 }
];

const leadSourceData = [
  { name: "Website", value: 77.4, color: "#6C63FF" },
  { name: "Instagram", value: 98.4, color: "#14b8a6" },
  { name: "Newsletter", value: 6.67, color: "#2f80ed" },
  { name: "WhatsApp", value: 9.4, color: "#f59e0b" }
];



export default function DashboardCards() {
  return (
    <Container fluid className="p-4">
      {/* section one  */}
      <Row className="g-4">

        {/* ------ > Leads Generated */}
        <Col lg={6}>
          <Card className="p-3 shadow-sm border-0">
            <Row className="align-items-center">


              <Col md={6}>
                <h6 className="text-muted  mb-3">
                  Leads Generated
                </h6>

                <div className="d-flex align-items-center mb-2">

                  <div
                    style={iconstyle}
                  >< HiMiniUserGroup size={22} color="#6c757d" />

                  </div>

                  <h2 className="fw-bold mb-0">68.30k</h2>
                </div>

                <div className="text-success fw-semibold">
                  9.32% ↑ <span className="text-muted ms-2">7.2k Up</span>
                </div>
              </Col>


              <Col md={6} style={{ height: 120 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart data={lineData}>


                    <defs>
                      <linearGradient id="colorLeads" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#4e73df" stopOpacity={0.35} />
                        <stop offset="100%" stopColor="#4e73df" stopOpacity={0} />
                      </linearGradient>
                    </defs>

                    <Tooltip
                      content={<CustomLineTooltip />}
                      cursor={{ strokeDasharray: "4 4" }}
                    />

                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke="#4e73df"
                      strokeWidth={3}
                      dot={false}
                      activeDot={{
                        r: 7,
                        stroke: "#fff",
                        strokeWidth: 3,
                        fill: "#4e73df"
                      }}
                    />


                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke="none"
                      fill="url(#colorLeads)"
                      fillOpacity={1}
                      activeDot={false}
                      dot={false}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </Col>

            </Row>
          </Card>
        </Col>


        {/* Qualified leads <---------- */}
        <Col lg={6}>
          <Card className="p-3 shadow-sm border-0">
            <Row className="align-items-center">

              <Col md={6}>
                <h6 className="text-muted  mb-3">
                  Qualified Leads
                </h6>
                <div className="d-flex align-items-center mb-2">
                  <div
                    style={iconstyle}
                  >
                    <FaUserCheck size={20} color="#6c757d" />
                  </div>

                  <h2 className="fw-bold mb-0">17.80k</h2>
                </div>

                <div className="text-danger fw-semibold">
                  6.95% ↓ <span className="text-muted ms-2">0.8k Down</span>
                </div>
              </Col>


              <Col md={6} style={{ height: 140 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <PieChart>
                    <Tooltip />
                    <Pie
                      data={pieData}
                      innerRadius={45}
                      outerRadius={60}
                      dataKey="value"
                    >
                      {pieData.map((entry, index) => (
                        <Cell key={index} fill={COLORS[index]} />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
              </Col>

            </Row>
          </Card>
        </Col>


        {/* ------ >Deals Closed section  */}
        <Col lg={6}>
          <Card className="p-3 shadow-sm border-0">
            <Row className="align-items-center">


              <Col md={6}>
                <h6 className="text-muted  mb-3">
                  Deals Closed
                </h6>

                <div className="d-flex align-items-center mb-2">


                  <div
                    style={iconstyle}
                  >
                    <FaBriefcase size={20} color="#6c757d" />
                  </div>

                  <h2 className="fw-bold mb-0">6.86k</h2>
                </div>

                <div className="text-success fw-semibold">
                  7.94% ↑ <span className="text-muted ms-2">5.3k Up</span>
                </div>
              </Col>


              <Col md={6} style={{ height: 120 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <LineChart data={dealData}>


                    <defs>
                      <linearGradient id="colorDeals" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#4e73df" stopOpacity={0.35} />
                        <stop offset="100%" stopColor="#4e73df" stopOpacity={0} />
                      </linearGradient>
                    </defs>

                    <Tooltip
                      content={<CustomDealsTooltip />}
                      cursor={{ strokeDasharray: "4 4" }}
                    />


                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke="#4e73df"
                      strokeWidth={3}
                      dot={false}
                      activeDot={{
                        r: 7,
                        stroke: "#fff",
                        strokeWidth: 3,
                        fill: "#4e73df"
                      }}
                    />


                    <Line
                      type="monotone"
                      dataKey="value"
                      stroke="none"
                      fill="url(#colorDeals)"
                      fillOpacity={1}
                      dot={false}
                      activeDot={false}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </Col>

            </Row>
          </Card>
        </Col>


        {/* Revenue Generated section <------ */}


        <Col lg={6}>
          <Card className="p-3 shadow-sm border-0">
            <Row className="align-items-center">
              <Col md={6}>
                <h6 className="text-muted mb-3">
                  Revenue Generated
                </h6>
                <div className="d-flex align-items-center mb-2">
                  <div
                    style={iconstyle}
                  >
                    <FaDollarSign size={20} color="#6c757d" />
                  </div>

                  <h2 className="fw-bold mb-0">$7.93M</h2>
                </div>

                <div className="text-success fw-semibold">
                  6.67% ↑ <span className="text-muted ms-2">$92.22k Up</span>
                </div>
              </Col>
              <Col md={6} style={{ height: 140 }}>
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={revenueData}>
                    <Tooltip content={<CustomBarTooltip />} cursor={false} />
                    <Bar
                      dataKey="value"
                      fill="#4e73df"
                      radius={[6, 6, 0, 0]}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </Col>

            </Row>
          </Card>
        </Col>


      </Row>

      {/* section two */}
      <Row className="g-4 my-4">


        <Col lg={8}>
          <Card className="p-4 shadow-sm border-0">


            <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
              <h5 className="fw-semibold">
                Overview <span className="text-muted">(Current Year)</span>
              </h5>

              <div className="d-flex gap-2">
                {["All", "1M", "6M", "1Y"].map((btn, i) => (
                  <Button
                    key={i}
                    size="sm"
                    variant={i === 0 ? "secondary" : "light"}
                  >
                    {btn}
                  </Button>
                ))}
              </div>
            </div>

            <Row>


              <Col md={4} className="mb-4">

                <div
                  style={{ background: "#fff4e5", padding: "15px", borderRadius: "10px", marginBottom: "20px" }}>
                  <p className="mb-0 text-warning">
                    We regret to inform you that our server is down.
                    <span className="fw-bold ms-1">Refresh</span>
                  </p>
                </div>

                <div className="d-flex flex-wrap gap-4">
                  <div className="mb-4">
                    <h6 className="text-muted">Revenue</h6>
                    <h4>$56.63k</h4>
                    <span className="text-danger">↓ 3.91%</span>
                  </div>

                  <div className="mb-4">
                    <h6 className="text-muted">Orders</h6>
                    <h4>9,842</h4>
                    <span className="text-success">↑ 8.72%</span>
                  </div>

                  <div className="mb-4">
                    <h6 className="text-muted">New Users</h6>
                    <h4>95k</h4>
                    <span className="text-success">↑ 11.2%</span>
                  </div>

                  <div className="mb-4">
                    <h6 className="text-muted">New Contract</h6>
                    <h4>851</h4>
                    <span className="text-muted">0%</span>
                  </div>
                </div>

                <Button variant="primary">
                  <FaSyncAlt className="me-2" />
                  Refresh Data
                </Button>
              </Col>


              <Col md={8}>
                <ResponsiveContainer width="100%" height={350}>
                  <BarChart data={chartData}>
                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip cursor={false} />
                    <Bar dataKey="green" fill="#14b8a6" radius={[6, 6, 0, 0]} />
                    <Bar dataKey="yellow" fill="#f59e0b" radius={[6, 6, 0, 0]} />
                    <Line
                      type="monotone"
                      dataKey="purple"
                      stroke="#6C63FF"
                      strokeWidth={3}
                      dot={false}
                    />
                  </BarChart>
                </ResponsiveContainer>
              </Col>

            </Row>
          </Card>
        </Col>


        <Col lg={4}>
          <Card className="p-4 shadow-sm border-0">

            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 className="fw-semibold">Lead Source</h5>
              <div className="d-flex gap-2">
                <Button size="sm" variant="light">
                  <FaDownload className="me-1" /> Export
                </Button>
                <Button size="sm" variant="secondary">
                  <FaUpload className="me-1" /> Import
                </Button>
              </div>
            </div>


            <ResponsiveContainer width="100%" height={280}>
              <PieChart>
                <Pie
                  data={leadSourceData}
                  innerRadius={70}
                  outerRadius={100}
                  dataKey="value"
                >
                  {leadSourceData.map((entry, index) => (
                    <Cell key={index} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>

            <div className="text-center mt-n5">
              <h5>Total</h5>
              <h3>578</h3>
            </div>


            <div className="mt-4 d-flex flex-wrap gap-4">

              <div className="d-flex justify-content-between mb-3">
                <div><FaBullhorn className="me-2 text-primary" />Newsletter</div>
                <div className="mx-1">6.67%</div>
              </div>

              <div className="d-flex justify-content-between mb-3">
                <div><SiWhatsapp className="me-2 text-success" />WhatsApp</div>
                <div className="mx-1" >9.4%</div>
              </div>

              <div className="d-flex justify-content-between mb-3">
                <div><FaInstagram className="me-2 text-danger" />Instagram</div>
                <div className="mx-1" >98.4%</div>
              </div>

              <div className="d-flex justify-content-between">
                <div><FaGlobe className="me-2 text-warning" />Website</div>
                <div className="mx-1" >77.4%</div>
              </div>

            </div>

          </Card>
        </Col>

      </Row>
    </Container>
  );
}
